<template>
    <div class="ma-5">
        <v-data-table
            :headers="headers"
            :items="desserts"
            :height="320"
            :search="search"
            :fixed-header="true"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Aplicativos</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.descricao_aplicativo"
                                                label="Descrição do Aplicativo*"
                                                autofocus
                                                :error-messages="nameErrors"
                                                @input="$v.editedItem.descricao_aplicativo.$touch()"
                                                @blur="$v.editedItem.descricao_aplicativo.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.src_aplicativo"
                                                label="Caminho Aplicativo*"
                                                :error-messages="srcErrors"
                                                @input="$v.editedItem.src_aplicativo.$touch()"
                                                @blur="$v.editedItem.src_aplicativo.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-select
                                                v-model="editedItem.idmodulo"
                                                :items="selects.modulos.items"
                                                chips
                                                label="Módulo do Sistema"
                                                height="10"
                                                outlined
                                                item-value="idmodulo"
                                                item-text="descricao_modulo"
                                                :error-messages="moduloErrors"
                                                @input="$v.editedItem.idmodulo.$touch()"
                                                @blur="$v.editedItem.idmodulo.$touch()"
                                            ></v-select>
                                        </v-col>
                                        <v-col class="pa-0 ml-5" cols="5">
                                            <v-select
                                                v-model="editedItem.rota"
                                                :items="selects.roteamento.items"
                                                chips
                                                label="Roteamento"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                :error-messages="roteamentoErrors"
                                                @input="$v.editedItem.rota.$touch()"
                                                @blur="$v.editedItem.rota.$touch()"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Aplicativo"
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    title="Remover Aplicativo"
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import AclAPI from "./../../api/acl";

    export default {
        props:['atualizarApp'],
        
        data: () => ({
            dialog: false,
            atualizar: 0,
            search: '',
            headers: [
                {
                    text: 'ID',
                    value: 'idaplicativo',
                },
                {
                    text: 'Aplicativo',
                    align: 'left',
                    value: 'descricao_aplicativo',
                },
                {text: 'Source File', value: 'src_aplicativo'},
                {text: 'Módulo', value: 'modulos[descricao_modulo]'},
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            selects: {
                modulos: {
                    items: [],
                },
                roteamento: {
                    items: [
                        {
                            id: true,
                            value: 'SIM'
                        },
                        {
                            id: false,
                            value: 'NÃO'
                        }
                    ],
                },
            },
            editedItem: {
                id: '',
                descricao_aplicativo: '',
                src_aplicativo: '',
                idmodulo: '',
                rota: '',

            },
            defaultItem: {
                id: '',
                descricao_aplicativo: '',
                src_aplicativo: '',
                idmodulo: '',
                rota: '',

            },
        }),

        validations: {
            editedItem: {
                descricao_aplicativo: {
                    required,

                },
                src_aplicativo: {
                    required,

                },
                idmodulo: {
                    required
                },
                rota: {
                    required,
                }
            }
        },

        computed: {
            nameErrors() {
                const errors = []
                if (!this.$v.editedItem.descricao_aplicativo.$dirty) return errors
                !this.$v.editedItem.descricao_aplicativo.required && errors.push('Campo Obrigatório.')
                return errors
            },
            srcErrors() {
                const errors = []
                if (!this.$v.editedItem.src_aplicativo.$dirty) return errors
                !this.$v.editedItem.src_aplicativo.required && errors.push('Campo Obrigatório.')
                return errors
            },
            moduloErrors() {
                const errors = []
                if (!this.$v.editedItem.idmodulo.$dirty) return errors
                !this.$v.editedItem.idmodulo.required && errors.push('Campo Obrigatório.')
                return errors
            },
            roteamentoErrors() {
                const errors = []
                if (!this.$v.editedItem.rota.$dirty) return errors
                !this.$v.editedItem.rota.required && errors.push('Campo Obrigatório.')
                return errors
            },

            formTitle() {
                return this.editedIndex === -1 ? 'Novo Aplicativo' : 'Editar Aplicativo'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },

            atualizarApp(){
                this.initialize()
            }
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                AclAPI.getModulos(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.selects.modulos.items = response.data.modulos;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                AclAPI.getAplicativos(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.desserts = response.data.aplicativos;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover aplicativo?')) {

                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.delAplicativo(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.editedItem = {}

                                    this.initialize();

                                    //atualizar permissoes
                                    this.$emit('atualizarPerm', this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }else{
                    this.editedItem = {}
                }

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid) {
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.addAplicativo(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                    //atualizar permissoes
                                    this.$emit('atualizarPerm', this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>